import { FormattedDate, FormattedTime } from 'react-intl';

type CustomFormattedDateProps = Intl.DateTimeFormatOptions & {
  value: Date | string | null | undefined;
  showDate?: boolean;
  showTime?: boolean;
  defaultValue?: string;
};

export function CustomFormattedDate({
  day = '2-digit',
  month = 'long',
  year = 'numeric',
  hour = '2-digit',
  minute = '2-digit',
  value,
  showDate = true,
  showTime = false,
  defaultValue = '-',
  ...props
}: CustomFormattedDateProps) {
  let date = value;

  if (typeof date === 'string') {
    date = new Date(date);
  }

  if (!(date instanceof Date && !Number.isNaN(date.getFullYear()))) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{defaultValue}</>;
  }

  return (
    <>
      {showDate && (
        <FormattedDate
          {...props}
          value={date}
          day={day}
          month={month}
          year={year}
        />
      )}

      {showDate && showTime && '  -  '}

      {showTime && (
        <FormattedTime {...props} value={date} hour={hour} minute={minute} />
      )}
    </>
  );
}
